import * as React from 'react';

/**
 * `.champ` du kit : un libellé au-dessus de sa saisie, une aide en dessous. Le libellé est un
 * <label> qui enveloppe — cliquer dessus donne le focus à la saisie sans avoir à apparier des
 * `id`. Pour un groupe qui n'est pas UNE saisie (des puces, un sélecteur de couleur), `group`
 * en fait un <fieldset>-like : `role="group"` nommé par le libellé.
 */
export function Field({
  label,
  hint,
  group = false,
  className,
  children,
}: {
  label: React.ReactNode;
  hint?: React.ReactNode;
  group?: boolean;
  className?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const id = React.useId();
  if (group) {
    return (
      <div className={className ? `champ ${className}` : 'champ'} role="group" aria-labelledby={id}>
        <span id={id} className="champ-libelle">
          {label}
        </span>
        {children}
        {hint && <p className="champ-aide">{hint}</p>}
      </div>
    );
  }
  return (
    <label className={className ? `champ ${className}` : 'champ'}>
      <span className="champ-libelle">{label}</span>
      {children}
      {hint && <span className="champ-aide">{hint}</span>}
    </label>
  );
}
